document.addEventListener('DOMContentLoaded', function() {

    const sections = document.querySelectorAll('.tall-image-cards-section');

    sections.forEach((section) => {

        const cards = section.querySelectorAll('.tic-card');

        function isDesktop() {
            return window.innerWidth >= 992;
        }

        function setActive(currentCard) {
            cards.forEach(card => card.classList.remove('is-active'));
            currentCard.classList.add('is-active');
        }

        function toggleActive(card) {
            const isActive = card.classList.contains('is-active');
            cards.forEach(c => c.classList.remove('is-active'));
            if (!isActive) {
                card.classList.add('is-active');
            }
        }

        cards.forEach((card) => {
            const plusIcon = card.querySelector('.icon-plus');

            card.addEventListener('mouseenter', function() {
                if (isDesktop()) {
                    setActive(card);
                }
            });

            card.addEventListener('mouseleave', function() {
                if (isDesktop()) {
                    card.classList.remove('is-active');
                }
            });


            card.addEventListener('click', function(e) {
                if (!isDesktop()) {return;}

                if (e.target.closest('.icon-plus')) {return;}
                setActive(card);
            });

            if (plusIcon) {
                plusIcon.addEventListener('click', function(e) {
                    e.stopPropagation();

                    if (!isDesktop()) {
                        toggleActive(card);
                    }
                });
            }
        });

        window.addEventListener('resize', function() {
            cards.forEach(card => card.classList.remove('is-active'));
        });

    });

});